import * as React from "react";

import { makeStyles, Grid, Container } from "@material-ui/core";
import { toast } from "react-toastify";

import IntroSection from "./components/IntroSection";
import InfoPart from "./components/InfoPart";
import { postApiService } from "../../../services/AgapeAPI";
import NewInfoPart from "./components/newInfoPart";
import NewIntroSection from "./components/newIntroSection";
import PaymentPageFooter from "./components/paymentPageFooter";
import CampaignDataComponent from "./components/campaignDataComponent";

// import GetWayModal from "../../common/getWayModal/paymentModal";

const useStyles = makeStyles((theme) => ({
  mainBackground: {
    backgroundColor: theme.palette.grey.light,
  },
  introContainer: {
    position: "relative",
    overflow: "hidden",
  },
  landContainer: (props) => ({
    position: "absolute",
    width: "100%",
    // left: '-10%',
    height: "54%",
    // borderRadius: '0 0 30% 35%',
    // backgroundImage: `url(${
    //   props.data.banner.length > 1 ? props.data.banner : LandImage
    // })`,
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: '100% 100%',
    // backgroundPosition: '40% 40%',
    zIndex: "2",
  }),
  greenContainer: {
    position: "absolute",
    width: "120%",
    height: "60%",
    borderRadius: "0 0 45% 40%",
    backgroundColor: "#009693",
    // transform: 'rotate(-1deg)',
    zIndex: "1",
  },
  container: {
    width: "100%",
    marginTop: 20,
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 2px 15px 0 #0001",
  },
  t1: {
    fontSize: 14,
    color: "#292929",
  },
  description: {
    fontFamily: "Vazir",
    fontSize: "14px",
    textAlign: "justify",
    maxWidth: "100% !important",
    "& *": {
      maxWidth: "100% !important",
      maxHeight: "100% !important",
    },
  },
  item: {
    padding: 15,
  },
  itemShare: {
    padding: 15,
    // borderTop: "solid 1px #B6B3B3",
    paddingBottom: 20,
    backgroundColor: "#FFFFFF",
    marginTop: "15px",
  },

  icon: {
    fontSize: 30,
    color: "#B6B3B3",
    marginBottom: "-10px",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      fontSize: 25,
    },
  },
  clickedIcon: {
    fontSize: 30,
    color: "#FF1339",
    marginBottom: "-10px",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      fontSize: 25,
    },
  },
  copy: {
    fontSize: 14,
    padding: "5px 10px",

    display: "inline-block",
    // margin: "0 20px",
    marginLeft: "20px",
    cursor: "pointer",
    color: "#292929",
    backgroundColor: "#F1EFEF",
    borderRadius: "10px",
    marginBottom: 10,
  },
  copyIcon: {
    fontSize: 20,
    display: "inline-block",
    marginBottom: "-5px",
    color: "#B6B3B3",
  },
  media: {
    width: 40,
    margin: "0 10px",
    display: "inline-block",
  },
}));

const PaymentMethodsDesktop = ({
  data,
  orgData,
  user,
  info,
  globalProps2,
  ...props
}) => {
  const classes = useStyles({ data });
  const opPay = async (data) => {
    try {
      const res = await postApiService("pay/dedicate-payments", data);
      window.location.href = res.data;
    } catch (ex) {
      toast.error("مشکلی پیش آمده است");
    }
  };
  return (
    <>
      <div className={classes.mainBackground}>
        <Container>
          <Grid container>
            <Grid item md={12}>
              {/* <InfoPart orgData={data} data={data} />{" "} */}
              <NewInfoPart
                orgData={data}
                data={data}
                globalProps2={globalProps2?.data}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <CampaignDataComponent data={data} />
            </Grid>

            <Grid item md={12} xs={12}>
              {/* <IntroSection
                orgData={data}
                data={data}
                info={info}
                opPay={opPay}
              />{" "} */}
              <NewIntroSection 
                globalProps2={globalProps2?.data}
              
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <PaymentPageFooter data={data} />
            </Grid>
          </Grid>
        </Container>
      </div>
      {/* <GetWayModal
        open={open}
        setOpen={setOpen}
        listData={listData?.data}
        defaultOptin={listData?.default}
        amount={paymentData?.amount}
        paymentData={paymentData}
        paymentQueries={[]}
        paymentApi={opPay}
      /> */}
    </>
  );
};

export default PaymentMethodsDesktop;
